<template lang="pug">
baseForm(@submit="register")
    template(#default="{ errors }")
        div(class="input-button-group flex")
            email(
                type="email"
                name="email"
                :placeholder="placeholderText"
                :isRequired="true"
                :isMaterial="false"
                v-model="email"
                aria-label="Subscribe"
                class="flex-grow"
            )
            BaseButton(
                size="XSMALL"
                type="submit"
                aria-label="Submit"
                :isWaiting="activateSpinner"
                :color="buttonColor"
                class="rounded-l-none"
                :hasCustomTextColor="hasCustomTextColor"
                :class="buttonClass"
            )
                slot
                    ChevronRightIcon(class="w-5 h-5 stroke-current")

        .error(v-if="errors") {{ errors['email'] }}
</template>

<script>
import baseForm from '@/components/form/'
import email from '@/components/form/input/email'
import BaseButton from '@/components/baseButton'
import ChevronRightIcon from '@/assets/common/chevronRight?inline'

export default {
    name: 'Subscribe',
    components: {
        baseForm,
        email,
        BaseButton,
        ChevronRightIcon,
    },
    props: {
        placeholderText: {
            type: String,
            default: 'Enter Email Address',
        },
        formName: {
            type: String,
            default: 'email-subscribe',
        },
        buttonColor: {
            type: String,
            default: 'ACTION',
        },
        buttonClass: {
            type: [String, Array],
            default: '',
        },
        hasCustomTextColor: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            activateSpinner: false,
            email: null,
        }
    },
    methods: {
        register() {
            if (this.activateSpinner) clearTimeout(this.timer)
            this.activateSpinner = true
            this.timer = setTimeout(() => {
                this.$uiEvents.$emit('newsletterSubscribed', {
                    formName: this.formName,
                    email: this.email,
                })
                this.activateSpinner = false
                this.$push.to('/newsletter-subscribe/')
            }, 500)
        },
    },
}
</script>

<style lang="stylus" scoped>
.input-button-group
    >>> input
        border-top-right-radius: 0
        border-bottom-right-radius: 0
        outline: 0
        border: none
</style>
